import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor] = useState(
    product?.colors?.[0] || ""
  );

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail main">
      <div className="product-detail-container">
        <div className="product-info-left">
          <div className="breadcrumb">
            {product.category} &rsaquo; {product.name}
          </div>

          <h1 className="product-title">{product.name}</h1>
          <div className="product-price">
            ${Number(product.price).toFixed(2)}
          </div>

          <div className="product-description">
            {product.description &&
              product.description.map((desc, idx) => <p key={idx}>{desc}</p>)}
          </div>

          <div className="product-features">
            {product.Features &&
              product.Features.map((feature, idx) => (
                <p key={idx}>{feature}</p>
              ))}
          </div>

          <div className="add-to-cart-section">
            <div className="quantity-label">Quantity:</div>
            <div className="quantity-value">1</div>

            <button className="add-to-cart-btn" onClick={handleAddToCart}>
              ADD TO CART
            </button>
          </div>
        </div>

        <div className="product-images-right">
          {product.images &&
            product.images.map((img, idx) => (
              <img key={idx} src={img} alt={`${product.name} ${idx + 1}`} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
